import { Typography } from '@material-ui/core';
import React, { Component } from 'react';

export class SearchIndexView extends Component {
  render() {
    return (
      <div>
        <Typography variant="h4" gutterBottom>
          SearchIndex Page
        </Typography>
      </div>
    );
  }
}

export default SearchIndexView;
